export default "__VITE_ASSET__ca5d436c__"